import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["feedback", "input", "preview"];
  static values = {
    maxFileSize: Number,
    type: String
  };

  preview(event) {
    if(this.handlePreview()) {
      return;
    }
  }

  humanFileSize(size) {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(2) * 1 + " " + ["B", "kB", "MB", "GB", "TB"][i];
  }

  handlePreview() {
    if(this.exceedsLimitOfMaxFileSize()) {
      return
    }
    this.feedbackTarget.classList.remove("text-red-700");
    this.feedbackTarget.innerHTML = ``;
    this.previewTarget.innerHTML = ''
    this.previewTarget.classList.remove("hidden")
    Array.from(this.inputTarget.files).forEach(file => {
      if(this.typeValue == "image") {
        this.previewImage(file);
      } else if(this.typeValue == "file") {
        this.previewFile(file);
      }
    });

  }

  exceedsLimitOfMaxFileSize() {
    let exceeds = false;
    Array.from(this.inputTarget.files).forEach(file => {
      if(file.size > this.maxFileSizeValue) {
        this.previewTarget.classList.add("hidden")
        this.previewTarget.innerHTML = ``
        this.inputTarget.value = null;
        this.feedbackTarget.classList.add("text-red-700");
        this.feedbackTarget.innerHTML = `<i class="icon-triangle-alert rounded-full p-1 mr-2 text-white bg-red-700"></i> File size exceeds the maximum allowed size of ${this.humanFileSize(this.maxFileSizeValue)}`;
        exceeds = true;
      }
    });

    return exceeds;
  }

  previewImage(file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      this.previewTarget.innerHTML += `<div class="p-3 text-sm text-gray-500 mr-3 text-center"><img src="${e.target.result}" class="inline-block w-32 h-32 object-cover rounded-md"><br/>${file.name} (${this.humanFileSize(file.size)})</div>`;
    }
    reader.readAsDataURL(file);
  }

  previewFile(file) {
    this.previewTarget.innerHTML += `<div class="p-3 text-sm text-gray-500 mr-3 text-center">${file.name} (${this.humanFileSize(file.size)})</div>`;
  }
}
